import { useCallback, useState } from "react"
import { centsClient } from "../../../api/cents/clients/cents-client"

interface SubscriptionRecurrenceChangeHook {
  refund: () => Promise<void>
  clearError: () => void
  error: 'deactivation_error' | undefined
  state: 'idle' | 'loading' | 'success'
}
export function useTransactionRefund(charityId: string, contractId: string, transactionId: string): SubscriptionRecurrenceChangeHook {
  const [error, setError] = useState<'deactivation_error'>()
  const [state, setState] = useState<'idle' | 'loading' | 'success'>('idle')

  const clearError = useCallback(() => {
    setError(undefined)
  }, [])

  const refund = useCallback(async () => {
    setState('loading')
    try {
      await centsClient.contracts.refundTransaction(charityId, contractId, transactionId)
    } catch {
      setError("deactivation_error")
      return
    } finally {
      setState('idle')
    }
    setState('success')
  }, [charityId, contractId, transactionId])

  return { refund, clearError, error, state }
}